module.exports = __webpack_public_path__ + "static/media/play.de8a708a.svg";